<template>  
<div> <!-- root element start -->

    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-12 col-lg-4">
              <contact-single-details @onSecComplete="onSecondary"></contact-single-details>
              <contact-single-org @onSecComplete="onSecondary"></contact-single-org>
            </div>

            <div class="col-12 col-lg-8">
              <component 
                :is="rightView" 
                :prop1="prop1" 
                :prop2="prop2" 
                :prop3="prop3" 
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete" 
                @onSecComplete="onSecondary"
              >
              </component>
            </div>

           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/contact-main-store.js'

import contactDetails from '../contactSinglePageComponents/contact-single-details.vue'
import contactOrg from '../contactSinglePageComponents/contact-single-org.vue'
import contactQuotes from '../contactSinglePageComponents/contact-single-quotes.vue'

import contactEdit from '../utilityComponents/contactComponents/contact-edit.vue'

// import addressEdit from '../utilityComponents/addressComponents/address-edit.vue'

import quoteCreate from '../utilityComponents/quoteComponents/quote-create.vue'
import viewQuote from '../utilityComponents/quoteComponents/quote-view.vue'
import emailQuote from '../utilityComponents/quoteComponents/quote-email.vue'

export default {
  store,
  props: ['contact'],
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getContactDetails();
    this.getContactQuotes();

    // this.getOrgContacts();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    getContactDetails() { this.$store.dispatch("getContactDetails", { contact: this.contact } ); }, 

    getOrgContacts() { this.$store.dispatch("getOrgContacts", { contact: this.contact } ); }, 

    getContactQuotes() { this.$store.dispatch("getContactQuotes", { contact: this.contact } ); }, 
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-save':
        // code to run the "get all contacts method" from store
        _this.getContactQuotes();
        _this.changeRightView('contact-single-quotes', '', '', '');
        break;
        case 'contact-edit':
        // code to run the "get all contacts method" from store
        _this.getContactDetails();
        _this.changeRightView('contact-single-quotes', '', '', '');
        break;
        case 'quote-email':
        var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-add':
          _this.changeRightView('contact-single-quotes', '', '', '');
        break;
        case 'contact-edit':
          _this.changeRightView('contact-single-quotes', '', '', '');
        break;
        case 'quote-view':
          _this.changeRightView('contact-single-quotes', '', '', '');
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    onSecondary(value){
      var _this = this;
      switch(value[0]) {
        case 'launchAddQuote':
          var setup = ['','',_this.org];
          _this.changeRightView('create-quote', '', '', setup);
        break;
        case 'launchEditContact':
          var setup = ['','',value[1]];
          _this.changeRightView('contact-edit', '', '', setup);
        break;
        case 'quote-view':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-email', '', '', setup);
        break;
        default:
      }
    },

  },    
  components:{
    'contact-single-details' : contactDetails,
    'contact-single-org' : contactOrg,
    'contact-single-quotes' : contactQuotes,

    // 'create-contact': contactCreate,
    
    'contact-edit' : contactEdit,
    // 'address-edit' : addressEdit,

    'create-quote': quoteCreate,
    'quote-view' : viewQuote,
    'quote-email' : emailQuote,
  },
  filters: {

  }
}
</script>
